module.exports = __webpack_public_path__ + "media/images/icon__checkmark@3x-a7679e4d06713f1889758b1b550d7a5d.png";